import React, { useMemo, useState } from "react";
import _ from "lodash";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import constants from "../../config/constants";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import AudioPlayer from "../common/AudioPlayer";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import LogsService from "../../utils/logs";
import getEnvEndpoints from "../../utils/endpoints";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";
import InteractiveRotaryGfx from "./InteractiveRotaryGfx";
import { isValidJSON } from "../../utils/helper";
import { getContentDetailsOnClick } from "../../utils/utility";
const endpoinds = getEnvEndpoints();

const RotaryCard = ({
  post,
  lookup,
  showPmbokModal,
  showShareModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id,
}) => {
  const [expanded, setExpanded] = useState(false);

  const additionalMedia = useMemo(() => {
    return _.find(post.referenceFiles, {
      fileKey: constants.fileKey.additionalMedia,
    });
  }, [post.referenceFiles]);

  const toggleExpand = async () => {
    getContentDetailsOnClick(post, "plus", "card-content");
    if (!canProceed()) return;

    if (!expanded) {
         if (post.isPublic && post.publishUntilDate && !((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        await LogsService.logViewItem({
          contentKey: post.contentKey,
          contentSubType: post.contentType,
        })
          .then(() => { })
          .catch(() => { });
      }
    }

    setExpanded(!expanded);
  };

  const audioFileUrl = additionalMedia
    ? endpoinds.baseContentUrl + additionalMedia.filePath
    : "";

  // can be used for cursor-pointer style
  const isValidContent = true;

  const postData = isValidJSON(post.data) ? JSON.parse(post.data) : {};

  const previewImage = previewImageOfPost(post);
  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div
                className={isValidContent ? "cursor-pointer" : ""}
                onClick={toggleExpand}
              >
                <CardSubheader subheader={post.title} isExpandable={false} />
              </div>
              {additionalMedia && (
                <AudioPlayer url={audioFileUrl} canProceed={canProceed} />
              )}
              {previewImage && !expanded && (
                <div
                  className="relative"
                  onClick={() => {
                    toggleExpand();
                  }}
                >
                  <div className="pin absolute image-overlay">
                    <i className="absolute fas fa-plus-circle text-white text-4xl md:text-6xl cursor-pointer play-button" />
                  </div>
                  <CardPreviewImage
                    previewImage={previewImage?.filePath || previewImage}
                  />
                </div>
              )}

              {expanded && (
                <InteractiveRotaryGfx
                  items={postData.items}
                  relations={postData.relations}
                  width={400}
                  title={postData.title || post.title}
                />
              )}

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              feedbacks={feedbacks}
              userLikes={userLikes}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default RotaryCard;
